<template>
    <v-layout row justify-center>
        <v-dialog
            v-model="showWarning"
            max-width="500px"
        >
            <v-card>
                <v-card-title class="headline">Inactivity Waring</v-card-title>
                <v-card-text>
                    No activity has been detected for 14 minutes. You will be logged out automtically unless you click within the window.
                </v-card-text>
            </v-card>
            
        </v-dialog>
    </v-layout>
</template>

<script>
export default {
    name: "InactivityWarning",

    data () {
        return {
            showWarning: false,
            events: ['click', 'mousedown', 'scroll', 'keypress'],
            warningTimer: null,
            logoutTimer: null,
        }
    },

    mounted() {
        this.events.forEach(function(event) {
            window.addEventListener(event, this.resetTimer)
        }, this);

        this.setTimers();
    },

    destroyed() {
        this.events.forEach(function(event) {
            window.removeEventListener(event, this.resetTimer);
        }, this);

        if(this.warningTimer != null)
            clearTimeout(this.warningTimer);

        if(this.logoutTimer != null)
            clearTimeout(this.logoutTimer);
    },

    methods: {
        setTimers: function() {
            this.warningTimer = setTimeout(this.warningTimeout, 14 * 60 * 1000);  // 14 minutes
            this.logoutTimer = setTimeout(this.logoutTimeout, 15 * 60 * 1000); // 15 minutes

            this.showWarning = false;
        },

        warningTimeout: function() {
            this.showWarning = true;
        },

        logoutTimeout: function() {
            clearTimeout(this.warningTimer);
            clearTimeout(this.logoutTimer);

            this.$store.dispatch("auth/logout");
            window.location.reload();
        },

        resetTimer: function () {
            clearTimeout(this.warningTimer);
            clearTimeout(this.logoutTimer);

            this.$store.dispatch("auth/refresh");

            this.setTimers();
        },
    }
}
</script>

<style scoped>

</style>